<template>
    <div id="app">
        <v-app id="inspire">
            <v-layout wrap>            
                <!-- maps page toolbar location -->
                <v-toolbar v-model="locationDialog" flat class="mt-5 elevation-1 hidden-md-and-up ma-0 pa-0 pt-0 title deep-orange  font-weight-regular white--text" @click="(useCurrentLoc(),attemp=1)">Use my current location <v-spacer></v-spacer><v-icon class="white--text">my_location</v-icon> 
                </v-toolbar>
                
                <!-- landing page toolbar location -->
                <v-flex>
                    <v-text-field class="font-weight-regular ma-0 pa-0 hidden-md-and-up" v-model="formattedAddress" :hide-details="true" solo label="Enter Place or Branch" append-icon="search" @click:append="(geoCoding())" @keyup.enter="(geoCoding())"></v-text-field>
                </v-flex>
                
                <v-dialog content-class="locationDialog hidden-sm-and-down" v-model="locationDialog" width="400" height="100" hide-overlay persistent>  
                    <v-card-title height=10 class="display-2 font-weight-light white--text">Book Appointment
                    </v-card-title>
                    
                    <v-card-title height=10 class="title deep-orange  font-weight-light white--text" @click="(useCurrentLoc(),attemp=1)">
                        <v-icon class="white--text">my_location</v-icon> Use my current location
                    </v-card-title>
                    
                    <v-flex>
                        <v-text-field class="font-weight-regular" :hide-details="true" v-model="formattedAddress" solo label="Enter Place or Branch" append-icon="search"  height="60"  @click:append="(geoCoding())" @keyup.enter="(geoCoding())">
                        </v-text-field>
                    </v-flex>
                </v-dialog>
                
                <v-carousel hide-controls height="auto" class="hidden-sm-and-down">
                    <v-carousel-item v-for="(item,i) in gallery" :key="i">
                        <img contain width="100%" :src="item.src">
                    </v-carousel-item>
                </v-carousel>

                <v-carousel hide-controls height="auto" class="hidden-md-and-up">
                    <v-carousel-item v-for="(item,i) in gallery" :key="i">
                        <img contain width="100%" :src="item.src">
                    </v-carousel-item>
                </v-carousel>

                <v-flex xs12 md12 lg12>
                    <v-footer dark height="auto" >
                        <v-card flat tile class="blue-grey darken-4 white--text text-xs-center" width="100%">
                            <br>
                            <v-card-text class="display-1 white--text pt-0">
                                Our Brands
                                <v-layout>
                                    <v-flex xs12 sm6 offset-sm3>
                                        <v-card class="blue-grey darken-4" flat>
                                            <v-layout>
                                                <v-flex v-for="(item,n) in logo" :key="n" xs4 d-flex>
                                                    <v-card flat>
                                                        <v-img class="blue-grey darken-4" contain width="100%" :src="item.src" aspect-ratio="1" > </v-img>
                                                    </v-card>
                                                </v-flex>
                                            </v-layout>
                                        </v-card>
                                    </v-flex>
                                </v-layout>
                            </v-card-text>

                            <v-card flat tile class="blue-grey darken-4 white--text text-xs-center" width="100%">
                                <v-expansion-panel>
                                    <v-expansion-panel-content class="blue-grey darken-4 white--text text-xs-center display-1">
                                        <template v-slot:header>
                                            <v-card-text class="blue-grey darken-4 white--text text-xs-center display-1">Our Services</v-card-text>
                                        </template>

                                        <v-container grid-list-sm fluid>
                                            <v-layout row wrap>
                                                <v-flex xs12 v-for="(category,index) in serviceCategory" :key="index" class="pt-0 pl-3 ">
                                                    <v-expansion-panel>
                                                        <v-expansion-panel-content class="blue-grey darken-4">
                                                            <template v-slot:header>
                                                                <div class="subheading font-weight-black text-uppercase">{{category}}</div>
                                                            </template>

                                                            <v-flex xs12 v-for="service in serviceMenu" :key="service.id" class="pt-0 pl-3" v-if="service.category==category">
                                                                <v-card-title class="subheading font-weight-regular pt-0 pb-0 pl-3">{{service.serviceName}}
                                                                </v-card-title>
                                                                <v-card-title class="caption font-weight-regular pt-0 pl-5">{{service.description}}
                                                                </v-card-title>
                                                            </v-flex>
                                                        </v-expansion-panel-content>
                                                    </v-expansion-panel>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-card>
                            <v-divider></v-divider>
                        </v-card>
                    </v-footer>
                </v-flex>

                <v-flex xs12 md12 lg12>
                    <v-footer dark height="auto">
                        <v-card flat tile class="blue-grey darken-4 white--text text-xs-center" width="100%">
                            <v-divider></v-divider>
                            <v-card-text class="white--text">
                            &copy;2020 — Service Scheduler. All Rights Reserved.<strong></strong>
                            </v-card-text>
                        </v-card>
                    </v-footer>
                </v-flex>
            </v-layout>

            <v-layout row justify-center>
                <v-snackbar class="font-weight-medium" v-model="showAlert" :color="alertColor" right bottom>
                    {{showAlertMessage}}
                    <v-btn small color="white" flat @click="showAlert = false"> Close </v-btn>
                </v-snackbar>

                <v-dialog  v-model="showProgress" persistent width="300">
                    <v-card color="blue-grey darken-4">
                        <v-card-text class="subheading white--text"> {{progressMessage}}
                            <v-layout row justify-center>
                            <v-progress-linear :indeterminate="true" :size="70" :width="5" color="white"
                            ></v-progress-linear>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </v-dialog>
            </v-layout>
        </v-app>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex"
import {db} from '../main'
import { gmapApi } from "vue2-google-maps"
import geolocation from 'vue-geolocation-api'

export default {
    data: () => ({
        formattedAddress: "",
        businessUnits: [],
        locationDialog: true,
        nearestbranch: {},
        sortBranches: [],
        currentPosition: {
            lat: null,
            lng: null
        },
        mapLat: 0,
        mapLng: 0,
        gallery: [
            {src: require('../img/SERVICE-SCHEDULER-BANNER.png')}
        ],
        logo: [
            {src: require('../img/New Project (5).png')},
            {src: require('../img/New Project (6).png')},
            {src: require('../img/New Project (7).png')},
            {src: require('../img/New Project (8).png')},
            {src: require('../img/New Project (9).png')},
        ],
        mapsBranchInfo: false,
        showAlert: false,
        showAlertMessage: "",
        branchWithAccess: [],
        alertColor: "",
        attemp: 0,
        progressMessage: "",
        showProgress: false,
        serviceMenu: [],
        serviceCategory: [
            "Tune Up",
            "Carburator & Fuel Injection System",
            "Top Overhauling",
            "Major Overhauling",
            "Side Overhauling",
            "Oil Seals",
            "Brake System",
            "Steering System",
            "Cables",
            "Drive Chain & V-Belt",
            "Front and Rear Wheel",
            "Electrical Wiring",
            "Other Services"
        ],
}),

    methods : {
        // ********* CONVERT INPUTED LOCATION TO COORDINATES *************
        geoCoding() {
            let self = this
            let geoCoordinates = []
            let url = "https://maps.googleapis.com/maps/api/geocode/json?address="+self.formattedAddress+"&key=AIzaSyDHAjcezNBpAbyyj9PwSnH5fplYE1o9cOE"
            self.sortBranches = []
            let instance = self.$axios.create()
            instance.defaults.headers.common = {}

            if (self.formattedAddress !== "") {
                self.$axios.get(url).then(result => {
                    result.data.results.forEach(function(doc){
                        geoCoordinates.push(doc.geometry)
                    })
                    console.log(geoCoordinates)
                    self.currentPosition = {
                        lat:  geoCoordinates[0].location.lat,
                        lng: geoCoordinates[0].location.lng
                    }
                    console.log(self.currentPosition)
                    setTimeout(() => {
                        self.goToPage(`branches/${self.currentPosition.lat}/${self.currentPosition.lng}/${self.formattedAddress}`)
                    }, 200)               
                    // if(self.currentPosition) {
                    //     result.data.results.forEach(function(doc){
                    //         geoCoordinates.push(doc.geometry)
                    //     })
                    //     self.currentPosition.lat = geoCoordinates[0].location.lat,
                    //     self.currentPosition.lng = geoCoordinates[0].location.lng
                    //     setTimeout(() => {
                    //        self.goToPage(`branches/${self.currentPosition.lat}/${self.currentPosition.lng}/${self.formattedAddress}`)`)
                    //     }, 200)                  
                    // } else {
                    //     self.showAlert=true
                    //     self.alertColor = "red accent-4"
                    //     self.showAlertMessage = "Please allow your location to proceed."
                    // }
                })
            } else {
                self.showAlert=true
                self.alertColor = "red accent-4"
                self.showAlertMessage = "Please input preferred location."
            }
        },

        // ********* FETCH CURRENT LOCATION *************
        useCurrentLoc() {
            let self = this
            let currentAddress = []
            let encodeUrl = encodeURI(self.formattedAddress)
            let url ="https://us-central1-servicescheduler-af9f2.cloudfunctions.net/reverse_geocoder" 
            self.progressMessage = "Loading..."
            self.showProgress = true
            self.$geolocation.getCurrentPosition().then(result => {
                if (result.coords) {
                    self.currentPosition = {
                        lat: result.coords.latitude,
                        lng: result.coords.longitude,
                    }
                    let body = {
                        'lat': self.currentPosition.lat,
                        'lng': self.currentPosition.lng
                    }  
                    self.mapLat = self.currentPosition.lat
                    self.mapLng = self.currentPosition.lng
                    self.$axios.post(url,body).then(result => {
                        result.data.forEach(function(doc){
                            currentAddress.push(doc.formatted_address)
                        })
                        self.formattedAddress = currentAddress[0]
                    }).then(function(){
                        self.showProgress = false
                        if (self.attemp === 1) {
                            setTimeout(() => {
                                self.goToPage(`branches/${self.currentPosition.lat}/${self.currentPosition.lng}/${self.formattedAddress}`)
                            }, 200)
                        }
                    }).catch(function(error) {
                        self.showProgress = false
                        console.log(error)
                    })
                }
            }).catch(function(error) {
                self.showProgress = false
                if (error.code == error.PERMISSION_DENIED) {
                    self.currentPosition = null
                    if (self.attemp === 1 && self.currentPosition === null) {
                        self.showAlert=true
                        self.alertColor = "red accent-4"
                        self.showAlertMessage = "Please allow your location to proceed."
                    }
                }
            })
        },

        async fetchServiceMenu() {
            let self = this
            self.serviceMenu = []   

            await db.collection("ServiceMenu"+self.$stage).get().then(function(querySnapshot){
                querySnapshot.forEach(function(doc){
                    if (doc.data().status == "active") {
                        self.serviceMenu.push(doc.data())
                    }
                })
            }).then(function(){
                self.serviceMenu.sort()
            }).catch(function(error){
                self.showAlert = true
                self.alertColor = "red accent-4"
                self.showAlertMessage="Error fetching document"
            })
        },

        // ********* R O U T E ***********
        goToPage(page) {
            this.$router.push("/"+page)
        },

        // async fetchSlides() {
        //     let self = this
        //     self.gallery = []
        //     await db.collection("Slides_dev")
        //     .get().then(function(querySnapshots) {
        //         querySnapshots.forEach(function(doc) {
        //             if (doc.data().tag == "Home Page" && doc.data().active == true && doc.data().url != "") {
        //                 self.gallery.push(doc.data())
        //             } 
        //         })
        //     })
        // },
    },

    mounted() {
        let self = this
        // self.fetchSlides()
        self.useCurrentLoc()
        self.fetchServiceMenu()
    },

    computed: {
        google: gmapApi,
        ...mapGetters(["user"]),
        ...mapState(["Auth"]),
    },

    watch: {

    }
}

</script>

<style>
    .locationDialog {
        position: absolute;
        top: 110px;
        left: 0px;
    }

    #logo-container {
    	margin-right: 50px;
    }

    #logo-container img {
        height: 50px;
        width:auto;
        border-radius: 10%;
    }
    
    a {
    text-decoration: none;
    }

    .fit {
        max-width: 100%;
        max-height: 100%;
    }
    .gm-style-mtc {
        display: none;
    }
 
</style>
